var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-detail-edit"}},[_c('user-nav',{attrs:{"userId":_vm.userId}}),_vm._v(" "),_c('back-btn'),_vm._v(" "),_c('h2',[_vm._v("\n    Edit User Details\n  ")]),_vm._v(" "),_c('user-detail-form',{attrs:{"userId":_vm.userId,"show-submit":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-792a0c82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserDetailEdit.vue
// module id = 1233
// module chunks = 1